<template>
  <mia-notice
    permanent
    title="Reserviert"
    type="warning"
  >
    <p>
      Dieses Fahrzeug wurde für <router-link
        :to="`/user/profile/${car.item_blocked_seller}`"
        v-text="blockedSellerFullName"
      /><span v-if="car.own_car && hasCustomer"> für den Kunden <router-link
        :to="`/legacy/customer_edit/${car.item_blocked_customer_id}`"
        v-text="blockedCustomerFullName"
      /></span> bis <span class="font-bold">{{ car.item_blocked_end }}</span> reserviert.
    </p>
    <p v-if="car.own_car">
      <button
        class="inline-flex items-center px-3 py-2 mt-2 text-sm transition-colors duration-100 ease-out bg-orange-100 border border-orange-300 rounded shadow text-orange-mia focus:outline-none focus:shadow-outline hover:bg-orange-mia hover:text-white"
        type="button"
        @click="unblock"
      >
        Reservierung löschen
      </button>
    </p>
  </mia-notice>
</template>

<script>
import Notice from '@/components/cars/edit/Notice.vue'
import { fullName } from '@/helpers/utils'

export default {
  name: 'MiaCarEditBlockedNotice',

  components: {
    'mia-notice': Notice
  },

  props: {
    car: {
      type: Object,
      required: true
    }
  },

  computed: {
    blockedSellerFullName() {
      return fullName(this.car.item_blocked_seller_lastname, this.car.item_blocked_seller_firstname)
    },

    blockedCustomerFullName() {
      const {
        item_blocked_customer_title: title,
        item_blocked_customer_company: company,
        item_blocked_customer_firstname: firstname,
        item_blocked_customer_name: name,
        item_blocked_customer_salutation: salutation
      } = this.car

      const parts = []

      if (salutation) {
        parts.push(salutation)
      }

      if (title) {
        parts.push(title)
      }

      if (name) {
        parts.push(`${name},`)
      }

      if (firstname) {
        parts.push(firstname)
      }

      return parts.join(' ').replace(/[,\s]+$/, '').replace(/^[,\s]+/, '')
    },

    hasCustomer() {
      return this.car.item_blocked_customer_id > 0
    }
  },

  methods: {
    unblock() {
      mia.car.block.trash(this.car.item_blocked_id, fullName(this.car.item_blocked_seller_lastname, this.car.item_blocked_seller_firstname))
    }
  }
}
</script>
